export default {
  'menu.welcome': 'ကြိုဆိုပါသည်',
  'menu.home': 'ပင်မ',
  'menu.dashboard': 'ဒက်ရှ်ဘုတ်',
  'menu.game-management': 'ဂိမ်းစီမံခန့်ခွဲမှု',
  'menu.game-management.robot-config': 'စက်ရုပ်ဆက်တင်',
  'menu.game-management.shan-rooms': 'Shankoemee အခန်းများ',
  'menu.game-management.boogyi-rooms': 'Boogyi အခန်းများ',
  'menu.game-management.shankoemee-history': 'Shankoemee မှတ်တမ်း',
  'menu.game-management.boogyi-history': 'Boogyi မှတ်တမ်း',
  'menu.game-management.tinyskm-history': 'TinySKM မှတ်တမ်း',
  'menu.game-management.jili-history': 'JILI မှတ်တမ်း',
  'menu.游戏管理.pragmatic-history': 'PP မှတ်တမ်း',
};
